import { Drawer, Text } from "@mantine/core";
import { IntegrationAppProvider } from "@membranehq/react";
import useWorkspaceStore from "../../store/workspace/workspaceStore";
import { generateIntegrationAppToken } from "../../services/integrationAppEndpoint";
import type { AssociatedObject } from "./types";
import EmailDetailsPanel from "./EmailDetailsPanel";

type EmailDetailsDrawerProps = {
  opened: boolean;
  onClose: () => void;
  email: AssociatedObject | null;
  position?: "left" | "right";
};

// Member-level IntegrationApp provider for email reply functionality
const MemberLevelIntegrationProvider = ({ children }: { children: React.ReactNode }) => {
  const workspace: any = useWorkspaceStore((state) => state.workspace);

  const fetchMemberLevelToken = async () => {
    if (workspace?.id) {
      try {
        const response = await generateIntegrationAppToken({
          workspace_id: workspace.id,
          isMemberLevel: true
        });
        return response?.data?.token;
      } catch (error) {
        console.error('Failed to fetch member-level integration token:', error);
        return null;
      }
    }
    return null;
  };

  return (
    <IntegrationAppProvider fetchToken={fetchMemberLevelToken}>
      {children}
    </IntegrationAppProvider>
  );
};

const EmailDetailsDrawer = ({ opened, onClose, email, position = "right" }: EmailDetailsDrawerProps) => (
  <Drawer
    opened={opened}
    onClose={onClose}
    position={position}
    size="760px"
    title={<Text fw={700} c="text.9">Email</Text>}
    overlayProps={{ blur: 4, opacity: 0.25 }}
    classNames={{
      header: "border-b border-gray-100",
      body: "p-4",
    }}
  >
    <MemberLevelIntegrationProvider>
      <EmailDetailsPanel email={email} />
    </MemberLevelIntegrationProvider>
  </Drawer>
);

export default EmailDetailsDrawer;
